<template>
  <div class="row">
    <div class="col-md-12 mb-3">
      <router-link to="/principal/users/add" class="btn btn-secondary" v-if="$can('create', 'Usuarios')">
        Agregar Usuario
      </router-link>
    </div>
    <div class="col-md-12">
      <vue-good-table
        mode="remote"
        :columns="columns"
        :rows="rows"
        :totalRows="totalRecords"
        :sort-options="{
          enabled: true,
        }"
        :isLoading.sync="isLoading"
        styleClass="vgt-table bordered"
        :pagination-options="{
          enabled: true,
          mode: 'registros',
          position: 'top',
          perPage: 10,
          nextLabel: 'siguiente',
          prevLabel: 'anterior',
          rowsPerPageLabel: 'Filas por página',
          ofLabel: 'de',
          pageLabel: 'páginas', // for 'pages' mode
          allLabel: 'Todos',
        }"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <button v-if="$can('config', 'Usuarios')" type="button" class="btn btn-secondary" @click="configureUser(props)">
              <font-awesome-icon :icon="['fa', 'cog']"/>
            </button>
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'

export default {
  mixins: [formatData],
  components: {
    VueGoodTable
  },
  data () {
    return {
      rows: [],
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'Nombre',
          field: 'fullname',
          filterOptions: {
            placeholder: 'Nombre de Usuario',
            enabled: true
          }
        },
        {
          label: 'Correo',
          field: 'email',
          filterOptions: {
            placeholder: 'Correo Electronico',
            enabled: true
          }
        },
        {
          label: 'Rol',
          field: 'role',
          filterOptions: {
            placeholder: 'Rol',
            enabled: true,
            filterMultiselectDropdownItems: []
          }
        },
        {
          label: 'Empresa',
          field: 'enterprise',
          filterOptions: {
            placeholder: 'Empresa',
            enabled: true,
            filterMultiselectDropdownItems: []
          }
        },
        {
          label: 'Acciones',
          field: 'actions',
          sortable: false
        }
      ]
    }
  },
  methods: {
    configureUser (props) {
      this.$router.push({ name: 'usersConfig', params: props })
    },
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange (params) {
      console.log(params)
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      this.loadItems()
    },
    async loadItems (first = false) {
      try {
        const items = {
          first: first,
          ...this.serverParams
        }
        const params = await this.toFormData(items)
        const response = await axiosAdelaService.post('/getUsers', params)
        console.log('getUsers', response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          this.rows = response.data.rows
          if (response.data.rolesFilter) {
            const roleColumn = this.$_.find(this.columns, (column) => {
              return column.field === 'role'
            })
            this.$_.set(roleColumn, 'filterOptions.filterMultiselectDropdownItems', response.data.rolesFilter)
          }

          if (response.data.enterprisesFilter) {
            const enterpriseColumn = this.$_.find(this.columns, (column) => {
              return column.field === 'enterprise'
            })
            this.$_.set(enterpriseColumn, 'filterOptions.filterMultiselectDropdownItems', response.data.enterprisesFilter)
          }
        }
      } catch (error) {
        this.showError('No se pudieron obtener los usuarios intentalo mas tarde.')
      }
    }
  },
  mounted () {
    this.loadItems(true)
  }
}
</script>

<style>

</style>
